angular.module('SpidApp')

.controller('BarcodePrintingController',
        ['$scope', 'ProductService', '$timeout', '$document', 'BarcodePageBuilder', 'SPID_CONFIG',
function ($scope,   ProductService,   $timeout,   $document,   BarcodePageBuilder,   SPID_CONFIG) {
    
    ProductService.all().then(function (products) {
        $scope.products = products
        
        $timeout(function () {
            _.each($scope.products, function (product, index) {
                try {
                    JsBarcode('#' + 'product-barcode-' + index, product.barcode, {
                          format       : SPID_CONFIG.products.barcodes.type
                        , width        : 2
                        , height       : 25
                        , displayValue : true
                    })

                    var elem = $document[0].getElementById('product-barcode-' + index)
                    product.dataURI = elem.src

                    product.pdfDataURI = BarcodePageBuilder.generate({
                          imageDataUri : product.dataURI
                        , label        : product.label
                        , barcode      : product.barcode
                    })
                    product.hasImage = true
                } catch(e) {
                    console.error(e, product.barcode)
                    product.hasImage = false
                }
            })
        }, 250)
    })
    
}])
